import { normalizeWidgetTheme, APIURL, appendFlatpickrBaseStyles, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, apiGet, toggleWidgetTheme, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin } from '../../helpers';
import { createGrid, GridOptions } from 'ag-grid-community';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from '../../types';
import flatpickr from 'flatpickr';
import rangeSlider from 'range-slider-input';
import 'range-slider-input/dist/style.css';
import { format } from 'date-fns';

export class TraderverseMarketAnalystPriceTargetMarketWide {
  private pageSize: number = 20;
  private container: HTMLElement;
  private config: WidgetConfig;
  private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
  private updateInterval: number | null = null;
  private shadowRoot: ShadowRoot;
  private widgetResizeObserver: ResizeObserver | null = null;
  private outsideClickListener: ((e: MouseEvent) => void) | null = null;
  private startDate: string = '';
  private endDate: string = '';
  private datePickerInstance: any = null;
  private analystOrFirm: string = '';
  private timePeriodFilter: string = 'ThisMonth';
  private targetChangeFilter: string = 'All';
  private sectorFilter: string = 'All';
  private minPercent: number | null = 0;
  private maxPercent: number | null = 100;
  private filterDebounceTimer: number | null = null;
  private rangeSliderApi: any = null;
  private gridApi: any = null;

  constructor(config: WidgetConfig) {
    this.config = { ...this.getDefaultConfig(), ...config };
    this.config.theme = normalizeWidgetTheme(this.config.theme);
    this.container = this.resolveContainer(config.container);

    if ((this.container as any).shadowRoot) {
      this.shadowRoot = (this.container as any).shadowRoot;
    } else {
      this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
    }
    this.init();

    this.widgetResizeObserver = new ResizeObserver(() => {
      this.updateDisplay();
    });
    setTimeout(() => {
      const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
      if (widget) this.widgetResizeObserver?.observe(widget);
    }, 0);
  }


  private fetchSymbols(): Array<{ value: string; label: string }> {
    return [
      { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
      { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
      { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
      { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
      { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
    ];
  }

  private getDefaultConfig(): Partial<WidgetConfig> {
    const symbols = this.fetchSymbols();
    return {
      headerPinned: true,
      symbol: 'MSFT',
      theme: 'default-dark',
      width: '100%',
      height: '400px',
      autosize: true
    };
  }

  private resolveContainer(container: string | HTMLElement): HTMLElement {
    if (typeof container === 'string') {
      const el = document.getElementById(container) || document.querySelector(container);
      if (!el) throw new Error(`Container not found: ${container}`);
      return el as HTMLElement;
    }
    return container;
  }

  private async init(): Promise<void> {
    if (!this.config.symbol) this.config.symbol = 'MSFT';

    const today = new Date();
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(today.getDate() - 5);
    this.startDate = fiveDaysAgo.toISOString().split('T')[0];
    this.endDate = today.toISOString().split('T')[0];

    this.createWidget();
    await this.attachStyles();

    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    if (widget) widget.classList.add('loading');
    await this.injectChartLibrary();
    this.updateDisplay();
    if (widget) widget.classList.remove('loading');
    this.emit('ready', {});
    this.config.onReady?.();
    cancelSelectEvent(this.shadowRoot);
  }

  private createWidget(): void {
     let themeClass = 'defaultDarkMode';
let dataTheme = 'default-dark';

if (this.config.theme === 'white') {
  themeClass = 'whiteMode';
  dataTheme = 'white';
} else if (this.config.theme === 'black') {
  themeClass = 'blackMode';
  dataTheme = 'black';
} else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
    const widgetHtml = `
       <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-theme="${dataTheme}">
        <div class="headTop">
          <h4 class="title market">${this.getTitleIconSvg()} Analyst Price Targets</h4>
          <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div></div>
        </div>

        <div class="inBody">
          <div class="optionsRow">

            ${this.config.hideSymbol ? '<div class="item dropStyle01"></div>' : `<div class="item dropStyle01">
            <div class="trader-sm-card" id="selected-symbol">
                ${getTraderSMCardHTML(this.config.stock ?? { symbol: this.config.symbol!, type: "stock", name: "" })}
                </div>
                <span id="symbol-dropdown-placeholder"></span>
            </div>`}
            <span></span>

            <div class="filtersBox sideBar hidden">
              <div class="item">
                <input type="text" class="analyst-input" placeholder="Analyst or Firm" />
              </div>

              <div class="item">
                <select class="timeperiod-select">
                  <option value="Today">Today</option>
                  <option value="ThisWeek">This Week</option>
                  <option value="ThisMonth" selected>This Month</option>
                  <option value="ThreeMonths">3 Months</option>
                </select>
              </div>

              <div class="item">
                <select class="targetchange-select">
                  <option value="All" selected>All</option>
                  <option value="Raised">Raised</option>
                  <option value="Lowered">Lowered</option>
                  <option value="Maintained">Maintained</option>
                </select>
              </div>

              <div class="item">
                <select class="sector-select">
                  <option value="All" selected>All</option>
                  <option value="Technology">Technology</option>
                  <option value="Financials">Financials</option>
                  <option value="Healthcare">Healthcare</option>
                  <option value="Consumer">Consumer</option>
                </select>
              </div>

              <div class="item percent-range">
                <div class="range-wrapper">
                  <div id="range-slider-container" class="range-slider-container"></div>
                  <div class="range-values">
                    <span class="min-label">0%</span>
                    <span style="margin:0 6px;">-</span>
                    <span class="max-label">100%</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          

          <div id="analystPriceTargetContainer" class="ag-theme-alpine-dark-- chart"></div>

        </div>
      </div>
    `;

    this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);
        if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
      const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
      const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
      if (placeholder && dropdown) {
        placeholder.replaceWith(dropdown);
      }
    }
    // if (this.config.isSymbolSelectable) {
    //       const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
    //       const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
    //       if (placeholder && dropdown) {
    //         placeholder.replaceWith(dropdown);
    //       }
    //     }

    // wire up filter controls
    this.wireFilterControls();
  }

  onSelectChange(stock: any) {
    this.changeSymbol(stock.symbol, stock);
  }

  private changeSymbol(stockId: string, stock: any = null): void {
    changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any) => this.setupChart(), (type: any, data: any) => this.emit(type, data));
  }

  private wireFilterControls(): void {
    const analyst = this.shadowRoot.querySelector('.analyst-input') as HTMLInputElement | null;
    const timeperiod = this.shadowRoot.querySelector('.timeperiod-select') as HTMLSelectElement | null;
    const targetchange = this.shadowRoot.querySelector('.targetchange-select') as HTMLSelectElement | null;
    const sector = this.shadowRoot.querySelector('.sector-select') as HTMLSelectElement | null;
    const minRange = this.shadowRoot.querySelector('.min-range') as HTMLInputElement | null;
    const maxRange = this.shadowRoot.querySelector('.max-range') as HTMLInputElement | null;
    const minLabel = this.shadowRoot.querySelector('.min-label') as HTMLElement | null;
    const maxLabel = this.shadowRoot.querySelector('.max-label') as HTMLElement | null;

    const trigger = () => this.triggerFetchDebounced();

    if (analyst) analyst.addEventListener('input', (e) => { this.analystOrFirm = (e.target as HTMLInputElement).value; trigger(); });
    if (timeperiod) timeperiod.addEventListener('change', (e) => { this.timePeriodFilter = (e.target as HTMLSelectElement).value; trigger(); });
    if (targetchange) targetchange.addEventListener('change', (e) => { this.targetChangeFilter = (e.target as HTMLSelectElement).value; trigger(); });
    if (sector) sector.addEventListener('change', (e) => { this.sectorFilter = (e.target as HTMLSelectElement).value; trigger(); });

    if (minRange) {
      minRange.addEventListener('input', (e) => {
        const v = parseFloat((e.target as HTMLInputElement).value);
        if (!isNaN(v)) {
          // ensure min does not exceed max
          if (maxRange && v > parseFloat(maxRange.value)) {
            maxRange.value = String(v);
            this.maxPercent = v;
            if (maxLabel) maxLabel.textContent = `${v}%`;
          }
          this.minPercent = v;
          if (minLabel) minLabel.textContent = `${v}%`;
          trigger();
        }
      });
    }

    if (maxRange) {
      maxRange.addEventListener('input', (e) => {
        const v = parseFloat((e.target as HTMLInputElement).value);
        if (!isNaN(v)) {
          // ensure max is not below min
          if (minRange && v < parseFloat(minRange.value)) {
            minRange.value = String(v);
            this.minPercent = v;
            if (minLabel) minLabel.textContent = `${v}%`;
          }
          this.maxPercent = v;
          if (maxLabel) maxLabel.textContent = `${v}%`;
          trigger();
        }
      });
    }

    const rangeContainer = this.shadowRoot.querySelector('#range-slider-container') as HTMLElement | null;
    if (rangeContainer && (rangeSlider as any)) {
      const wrapper = document.createElement('div');
      wrapper.className = 'range-slider';
      rangeContainer.innerHTML = '';
      rangeContainer.appendChild(wrapper);
      const minInit = this.minPercent ?? 0;
      const maxInit = this.maxPercent ?? 100;
      try {
        this.rangeSliderApi = (rangeSlider as any)(wrapper, {
          min: 0,
          max: 100,
          step: 1,
          value: [minInit, maxInit],
          onInput: (value: number[], userInteraction: boolean) => {
            this.minPercent = value[0];
            this.maxPercent = value[1];
            if (minLabel) minLabel.textContent = `${value[0]}%`;
            if (maxLabel) maxLabel.textContent = `${value[1]}%`;
            if (userInteraction) trigger();
          }
        });
      } catch (err) {
        console.warn('rangeSlider init failed', err);
        this.rangeSliderApi = null;
      }
    }
    const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
    const filtersToggle = this.shadowRoot.querySelector('.filters-toggle') as HTMLElement | null;
    if (filtersToggle && filtersBox) {
      filtersToggle.addEventListener('click', (ev) => {
        ev.stopPropagation();
        filtersBox.classList.toggle('hidden');
      });

      this.outsideClickListener = (e: MouseEvent) => {
        const path = (e.composedPath && e.composedPath()) || (e as any).path || [];
        if (path && path.indexOf(this.shadowRoot.host) > -1) return; // click occurred inside this widget
        filtersBox.classList.add('hidden');
      };
      document.addEventListener('click', this.outsideClickListener);
    }

  }

  private triggerFetchDebounced(delay = 300): void {
    if (this.filterDebounceTimer) {
      window.clearTimeout(this.filterDebounceTimer as any);
      this.filterDebounceTimer = null;
    }
    this.filterDebounceTimer = window.setTimeout(() => {
      this.setupChart();
      this.filterDebounceTimer = null;
    }, delay) as any;
  }

  private buildFetchPayload(offset: number, limit: number): Record<string, unknown> {
    const payload: Record<string, unknown> = {
      offset,
      limit
    };
    if (this.config.symbol) payload.symbol = this.config.symbol;
    if (this.analystOrFirm) payload.analystOrFirm = this.analystOrFirm;
    if (this.timePeriodFilter) payload.timePeriod = this.timePeriodFilter;
    if (this.targetChangeFilter) payload.targetChange = this.targetChangeFilter;
    if (this.sectorFilter && this.sectorFilter !== 'All') payload.sector = this.sectorFilter;
    if (this.minPercent !== null) payload.minPercent = this.minPercent;
    if (this.maxPercent !== null) payload.maxPercent = this.maxPercent;
    return payload;
  }

  private async fetchPage(startRow: number, limit: number): Promise<{ rows: any[]; totalCount: number }> {
    const payload = this.buildFetchPayload(startRow, limit);
    const query = new URLSearchParams(
      Object.entries(payload).reduce((acc, [k, v]) => {
        if (v !== undefined && v !== null && v !== '') acc[k] = String(v);
        return acc;
      }, {} as Record<string, string>)
    ).toString();
    const url = `${APIURL}/v1/discover/analyst-price-target${query ? `?${query}` : ''}`;
    const response = await apiGet({
      method: 'GET',
      url,
    });
    if (!response.ok) return { rows: [], totalCount: 0 };
    const data = await response.json();
    const result = (data.data && typeof data.data === 'object') ? data.data : data;
    const rawRows = Array.isArray(result.data) ? result.data : [];
    const rows = rawRows.map((item: any) => ({
      published_date: item.published_date,
      symbol: item.symbol,
      analyst_name: item.analyst_name,
      company_name: item.company_name,
      price_target: item.price_target,
      price_when_posted: item.price_when_posted
    }));
    const totalCount = typeof result.total_count === 'number' ? result.total_count
      : typeof (result as any).totalCount === 'number' ? (result as any).totalCount
      : 0;
    return { rows, totalCount };
  }

  private createDatasource(): { getRows: (params: any) => void } {
    return {
      getRows: (params: { startRow: number; endRow: number; successCallback: (rows: any[], lastRow: number) => void; failCallback?: () => void }) => {
        const startRow = params.startRow;
        const limit = params.endRow - params.startRow;
        this.fetchPage(startRow, limit)
          .then(({ rows, totalCount }) => {
            const lastRow = totalCount > 0 ? totalCount : 0;
            params.successCallback(rows, lastRow);
            this.emit('dataUpdate', { total_count: totalCount, data: rows });
          })
          .catch(() => {
            params.failCallback?.();
          });
      }
    };
  }

  private gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Date',
        field: 'published_date',
        valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString('en-GB').replace(/\//g, '-') : '-',
        minWidth: 100
      },
      { headerName: 'Name', field: 'analyst_name', minWidth: 120 },
      { headerName: 'Company Name', field: 'company_name', minWidth: 180 },
      { headerName: 'Price Target', field: 'price_target', minWidth: 100 },
      {
        headerName: 'Price Post',
        field: 'price_when_posted',
        cellRenderer: (params: any) => `<span class="stat">${params.value ?? '-'}</span>`,
        minWidth: 100
      }
    ],
    rowModelType: 'infinite',
    cacheBlockSize: this.pageSize,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    infiniteInitialRowCount: 1,
    domLayout: 'autoHeight',
    suppressMovableColumns: true,
    suppressMenuHide: true,
    pagination: true,
    paginationPageSize: this.pageSize,
    defaultColDef: {
      flex: 1,
      resizable: true,
      sortable: true,
      filter: true,
    },
    overlayNoRowsTemplate: '<span>No data available</span>',
    onGridReady: (params) => {
      params.api.setGridOption('datasource', this.createDatasource());
    }
  };

  private renderAnalystPriceTargetsGrid(): void {
    const container = this.shadowRoot.querySelector('#analystPriceTargetContainer');
    if (!container) return;

    if (this.gridApi) {
      this.gridApi.setGridOption('datasource', this.createDatasource());
      this.gridApi.purgeInfiniteCache();
      return;
    }

    this.gridApi = createGrid(container as HTMLElement, {
      ...this.gridOptions,
      datasource: this.createDatasource()
    });
  }

  private async attachStyles(): Promise<void> {
    try {
      appendFlatpickrBaseStyles(this.shadowRoot);
      const styleEl = await getCSSStyles();
      this.shadowRoot.appendChild(styleEl);
      // Scoped overrides to fix range slider UI inside the filters sidebar
      const customStyle = document.createElement('style');
      customStyle.textContent = `
        
      
      `;
      this.shadowRoot.appendChild(customStyle);
    } catch (err) {
      console.error('Failed to load CSS file:', err);
    }
  }

  private async injectChartLibrary(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if ((window as any).echarts) return resolve(true);
      if (this.shadowRoot.querySelector('script[data-chart-lib]')) {
        const script = this.shadowRoot.querySelector('script[data-chart-lib]') as HTMLScriptElement;
        script.onload = () => resolve(true);
      } else {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
        script.async = true;
        script.setAttribute('data-chart-lib', 'true');
        this.shadowRoot.appendChild(script);
        script.onload = () => resolve(true);
      }
    });
  }

  private async setupChart(): Promise<void> {
    if (this.gridApi) {
      this.gridApi.setGridOption('datasource', this.createDatasource());
      this.gridApi.purgeInfiniteCache();
    } else {
      this.updateDisplay();
    }
  }

private updateDisplay(): void {
  const container = this.shadowRoot.querySelector('#analystPriceTargetContainer') as HTMLElement;

  if (!container) return;

  const hasData = this.gridApi && this.gridApi.getDisplayedRowCount?.() > 0;

  if (hasData) {
    container.setAttribute('data-testing-id', 'analyst-price-target-grid');
  } else {
    container.removeAttribute('data-testing-id');
  }

  this.renderAnalystPriceTargetsGrid();
}

  public on(type: WidgetEventType, handler: WidgetEventHandler): void {
    if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
    this.eventHandlers.get(type)!.push(handler);
  }

  public off(type: WidgetEventType, handler: WidgetEventHandler): void {
    const list = this.eventHandlers.get(type);
    if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
  }

  public setSymbol(symbol: string): void {
    this.changeSymbol(symbol);
    const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
    if (dropdown) dropdown.value = symbol;
  }

  public setPriceRange(min: number | null, max: number | null, applyImmediately = true): void {
    this.minPercent = min;
    this.maxPercent = max;
    const minRange = this.shadowRoot.querySelector('.min-range') as HTMLInputElement | null;
    const maxRange = this.shadowRoot.querySelector('.max-range') as HTMLInputElement | null;
    const minLabel = this.shadowRoot.querySelector('.min-label') as HTMLElement | null;
    const maxLabel = this.shadowRoot.querySelector('.max-label') as HTMLElement | null;
    const minVal = min === null ? 0 : min;
    const maxVal = max === null ? 100 : max;
    if (minRange) minRange.value = String(minVal);
    if (maxRange) maxRange.value = String(maxVal);
    if (minLabel) minLabel.textContent = `${minVal}%`;
    if (maxLabel) maxLabel.textContent = `${maxVal}%`;
    if (applyImmediately) {
      if (this.rangeSliderApi && typeof this.rangeSliderApi.value === 'function') {
        const minValNum = minVal;
        const maxValNum = maxVal;
        try { this.rangeSliderApi.value([minValNum, maxValNum]); } catch (e) { /* ignore */ }
      }
      this.setupChart();
    }
  }

  public async getWidgetImage(): Promise<string> {
    const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
    return await getWidgetDataURI(widget);
  }

  public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
  if (!this.shadowRoot) return;

  this.config.theme = toggleWidgetTheme(
    this.shadowRoot,
    theme
  ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';

  this.updateDisplay();
}

  public destroy(): void {
    if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
    if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
    if (this.outsideClickListener) {
      document.removeEventListener('click', this.outsideClickListener);
      this.outsideClickListener = null;
    }
    if (this.rangeSliderApi && typeof this.rangeSliderApi.removeGlobalEventListeners === 'function') {
      try { this.rangeSliderApi.removeGlobalEventListeners(); } catch (e) { /* ignore */ }
      this.rangeSliderApi = null;
    }
    this.gridApi = null;
    this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
  }

  private emit(type: WidgetEventType, data: any): void {
    const handlers = this.eventHandlers.get(type);
    if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
  }
  private getTitleIconSvg(): string {
    return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
  }

}

declare global { interface Window { TraderverseMarketAnalystPriceTargetMarketWide: typeof TraderverseMarketAnalystPriceTargetMarketWide; } }
if (typeof window !== 'undefined') { window.TraderverseMarketAnalystPriceTargetMarketWide = TraderverseMarketAnalystPriceTargetMarketWide; }
